// global vars
var bShopsLookedUp = false;
var screenWidth = $(window).width();
// this variable will contain the sku specific data and is used througout the rest of the script after setting it. This should always be the case.
var oSelectedSizeData = {};
$(function()
{
	$(el('mainContainer')).on('click', "#btnAddProductLendout", function(evt)
	{
		var sSkuId = getSelectedSku();
		if(sSkuId && getSkuQty() > 0) {
			checkMultiplier($(el('edtQty')));
			$('#btnAddProductLendout').ajaxLoader('show')
			var oBtn = $(this);
			oBtn.prop('disabled', true);
			var sLendoutId = $('.headerLendingIcon').data('lendoutid');
			var iQty = $(el('edtQty')).val();
			var sCollectMethod = $(this).data('collectMethod');
			var sShopId        = $(this).data('shopId');
			var sShopStockId   = (typeof $(this).data('shopStockId') !== "undefined")?$(this).data('shopStockId'):sShopId;
			var sParams = '&lendoutId=' + sLendoutId;
			if ($(this).hasClass('isLendout')) {
				sParams += '&skuId=' + sSkuId + '&qty=' + iQty;
				uAjax = "/index.cfm/product/ajax/updateLendoutProduct";
				var oCall = callAjax("updateLendoutProduct", sParams, "post");

			} else {
				sParams += '&skuid=' + sSkuId + '&qty=' + iQty + '&shopid=' + sShopId + '&shopstockid=' + sShopStockId + '&collectmethod=' + sCollectMethod;
				uAjax = "/index.cfm/product/ajax/addProductToLendout";
				var oCall = callAjax("addProductToLendout", sParams, "post");
			}
			oCall.success(function(oData) {
				if(oData.errorType === 'lendingOrderNotInDraft' )
				{
					window.location.reload();
				}
				else if (oData.errorType != '')
				{
					showAlert('error', oData.errorMessage, false);
				}
				else
				{
					showAlert('warning',tAddedToLendoutAlert, false);
					$('.lendoutQuantity').text(oData.lendoutQty);
					if (oData.lendoutQty > 0) {
						$('.lendoutQuantity').removeClass('hide');
					} else {
						$('.lendoutQuantity').addClass('hide');
					}
					window.location = '/' + sCurrentLanguageCode + '/product/lendout'
				}
				oBtn.ajaxLoader('hide')
				oBtn.prop('disabled', false);
			});
		}
	});
	// Add product to basket (home delivery)
	$('#btnAddProduct, .btnIsHomeDelivery').on('click', function(evt)
	{
		var sSku = getSelectedSku();
		if(sSku && getSkuQty() > 0)
		{
			checkMultiplier($(el('edtQty')));
			var sCollectMethod = $(this).data('collectMethod');
			var sShopId        = $(this).data('shopId');
			var sShopStockId   = (typeof $(this).data('shopStockId') !== "undefined")?$(this).data('shopStockId'):sShopId;
			var bShopdefaultForConfiguration = (typeof $(this).data('shopdefaultForConfiguration') !== "undefined")?$(this).data('shopdefaultForConfiguration'):false;
			var bReserveNow    = ($(this).data('reserve') === true) ? true:false;

			$(document).trigger( "addProduct",[sSku, getSkuQty(), sShopId, sCollectMethod, $(this).ajaxLoader('show'), 'hd']);

			if($('.addons').length > 0 && getSelectedAddons().length > 0)
			{
				var oSelectedSku = {};
				var size = $('.size-item.selected').text().replaceAll('\t', '').replaceAll('\n', '');
				var colour = $('.swatch-item.selected img').prop('title').replaceAll(/\t+/g, "");
				oSelectedSku.description = sWebName;
				if(!bOneColourOneSize)
				{
					oSelectedSku.description += " " + colour + " " + size;
				}
				oSelectedSku.quantity = getSkuQty();
				oSelectedSku.skuId = sSku;

				var addons = getSelectedAddons();
				addons.push(oSelectedSku);

				sAddons = JSON.stringify(addons);
				addConfiguration(sCollectMethod,sShopId,bReserveNow,sAddons,oSelectedSku.skuId,oSelectedSku.quantity, $(this).ajaxLoader('show'),bShopdefaultForConfiguration)
			}
			else
			{
				var ccMethod   = (typeof $(this).data('clickcollectMethod') !== "undefined")?$(this).data('clickcollectMethod'):'';
				if (bDoNotDisplayHDBlockedOnPDP && $(this).data('collectMethod') === ccMethod) {
					addProduct(sSku, getSkuQty(), sShopId, sCollectMethod, $(this).ajaxLoader('show'), 'cc', undefined, false, sShopStockId);
				} else {
					addProduct(sSku, getSkuQty(), sShopId, sCollectMethod, $(this).ajaxLoader('show'), 'hd', undefined, false, sShopStockId);
				}
			}
		}
		else if(typeof bDontTriggerFirstClick !== 'undefined' && bDontTriggerFirstClick)
		{
			if ($('.swatch-item').length>1 && $('.swatch-item.selected').length == 0){
				$('#selection-title').addClass('redWarningText');
				$('.product-a2b .input-prepend.input-append').addClass('redWarningText');
				$('#errorSwatch').css('display', 'block');
			}

			if ($('.size-item.selected').length == 0){
				$('#selectSizeText').addClass('redWarningText');
				$('.product-a2b .input-prepend.input-append').addClass('redWarningText');
				$('#errorSize').css('display', 'block');
			}
		}

		return false;
	});

	// Add product to basket (Click & Collect)
	$(el('ccShopsContainer')).on('click', '#ccShops .triggercc', function (evt) {
		$("#ccShops .collect:not(.disabled)").trigger("click");

	});

	$(el('mainContainer')).on('change', 'input[type=radio].addonRadio, .addons select.addonSelect' , function() {
		updatePrice();
	 });

	$(el('ccShopsContainer')).on('click', '#ccShops .collect:not(.disabled)', function(evt)
	{

		var sSku = getSelectedSku();
		if(sSku)
		{
			var sCollectMethod = $(this).data('collectMethod');
			var sShopId        = $(this).data('shopId');
			var sShopStockId   = (typeof $(this).data('shopStockId') !== "undefined")?$(this).data('shopStockId'):sShopId;
			var bShopdefaultForConfiguration = (typeof $(this).data('shopdefaultForConfiguration') !== "undefined")?$(this).data('shopdefaultForConfiguration'):false;
			var bReserveNow    = ($(this).data('reserve') === true) ? true:false;

			$(document).trigger( "addProduct",[sSku, getSkuQty(), sShopId, sCollectMethod, $(this).ajaxLoader('show'), 'cc']);

			if($('.addons').length > 0 && getSelectedAddons().length > 0)
			{
				var oSelectedSku = {};
				var size = $('.size-item.selected').text().replace('\t', '');
				var colour = $('.swatch-item.selected img').prop('title').replace(/\t+/g, "");
				oSelectedSku.description = sWebName + " " + colour + " " + size;
				oSelectedSku.quantity = getSkuQty();
				oSelectedSku.skuId = sSku;

				var addons = getSelectedAddons();
				addons.push(oSelectedSku);

				sAddons = JSON.stringify(addons);
				addConfiguration(sCollectMethod,sShopId,bReserveNow,sAddons,oSelectedSku.skuId,oSelectedSku.quantity, $(this).ajaxLoader('show'),bShopdefaultForConfiguration)
			}
			else
			{
				addProduct(sSku, getSkuQty(), sShopId, sCollectMethod, $(this).ajaxLoader('show'), 'cc',undefined, false, sShopStockId);
			}
		}
	});

	// Add product to basket (Pickup Point)
	$(el('ccShopsContainer')).on('click', '#pickuppoints .collect:not(.disabled)', function(evt)
	{
		var sSku = getSelectedSku();
		if(sSku)
		{
			var sCollectMethod = $(this).data('collectMethod');
			var sPointId       = $(this).data('pointId');
			var sShopId        = $(this).data('shopId');
			var sShopStockId   = (typeof $(this).data('shopStockId') !== "undefined")?$(this).data('shopStockId'):sShopId;
			addProduct(sSku, getSkuQty(), sShopId, sCollectMethod, $(this).ajaxLoader('show'), 'pp', sPointId ,false, sShopStockId);
		}
	});

	// Add product to sku selection
	$(el('btnAddToCustomerProductList')).on('click', function(evt)
	{
		var sSku = getSelectedSku();
		if(sSku)
		{
			checkMultiplier($(el('edtQty')));
			var sCollectMethod = $(this).data('collectMethod');
			var sShopId        = $(this).data('shopId');
			var qty = (typeof getSkuQty() !== "undefined") ? getSkuQty() : "1";

			if($(el('customerProductListOrderQtyPicker')).length > 0)
			{
				qty = $(el('customerProductListOrderQtyPicker')).val();
			}

			if($(this).data('count') > 1)
			{
				var oContent = $('.customerProductListSelectors').html();
				showFullScreenPopup(oContent,'','pdpCustomerProductLists');
			}
			else
			{
				var sId                  = $(this).data('mainList');
				var oCustomerProductList = $('.customerProductListSelectors').find('.customerProductListSelector[data-id="' + sId + '"]');
				if(oCustomerProductList.attr('data-skus').toString().indexOf(sSku) < 0)
				{
					addToCustomerProductList(sId, sSku, qty, sShopId, $(this).ajaxLoader('show'));
				}
				else
				{
					showAlert('warning', tWarningSkuAlreadyInList, false, 3000);
				}
			}
		}
		return false;
	});

	$('body').on('click', '.customerProductListSelector', function(evt)
	{
		var sSku = getSelectedSku();
		if(sSku)
		{
			if($(this).attr('data-skus').toString().indexOf(sSku) < 0)
			{
				checkMultiplier($(el('edtQty')));
				var sCollectMethod = $(this).data('collectMethod');
				var sId            = $(this).data('id');
				var sShopId        = $(this).data('shopId');
				var qty = (typeof getSkuQty() !== "undefined") ? getSkuQty() : "1";

				if($(el('customerProductListOrderQtyPicker')).length > 0)
				{
					qty = $(el('customerProductListOrderQtyPicker')).val();
				}

				addToCustomerProductList(sId, sSku, qty, sShopId, $(this).ajaxLoader('show'));
			}
			else
			{
				showAlert('warning', tWarningSkuAlreadyInList, false, 3000);
			}
		}
		return false;
	});

	// Check multiplier on qty change
	$(el('mainContainer')).on('change', '#edtQty', function(evt)
	{
		checkMultiplier($(el('edtQty')));
	});

	$(el('mainContainer')).on('click', '.showMoreAddons', function(evt)
	{
		$(this).hide();
		$(this).closest(".addon-wrapper").find(".addon-label").removeClass("hide");
	});

	// find C&C shops
	$(el('btnShopLookup')).on('click', function()
	{
		var sPostalCode = $(el('edtPostalcode')).val();
		findShops(sPostalCode);
		return false;
	});

	// size swatch click
	$('.size-item').on('click',function(oEvent)
	{
		if(oEvent.originalEvent !== undefined)
		{
			$(document).trigger("logCustomEvent",['Product','Size',$(this).html()]);
		}
		populateSizeData($(this),'swatch');
		handleSizeChange($(this),'swatch');
	});

	// size dropdown change
	$(el('mainContainer')).on('change', '.selectSizes', function(oEvent)
	{
		if(oEvent.originalEvent !== undefined)
		{
			$(document).trigger("logCustomEvent",['Product','Size',$(this).children('option:selected').html()]);
		}
		populateSizeData($(this),'dropdown');
		handleSizeChange($(this).children('option:selected'),'dropdown');
	});

	// colour swatch click
	$('.swatch-item').on('click',function()
	{
		var bAutoSelectSize = true;
		var oSizes          = $('#size'+$(this).data('value')).children();

		handleColourChange($(this),'swatch');

		if(typeof bDontTriggerFirstClick !== 'undefined' && bDontTriggerFirstClick)
		{
			bAutoSelectSize   = (oSizes.length == 1);
			oSelectedSizeData = {};

			$('.size-item').removeClass('selected');
		}

		if(bAutoSelectSize)
		{
			// Handle New Selected Size
			var oFirst = (oSizes.not('.disabled').length > 0) ? oSizes.not('.disabled').first() : oSizes.first();
			oFirst.trigger('click');
		}
	});

	// colour dropdown change
	$(el('mainContainer')).on('change','.selectColour',function()
	{
		handleColourChange($(this),'dropdown');
		// Handle New Selected Size
		$('.selectSizes:visible').trigger('change');
	});


	$('.product-img .overlay').on('click',function()
	{
		$(this).closest('.product-img').find('.fancybox').trigger('click');
	});


	$('#btnSubscribeRegisterNotify').on('click', function() {
		subscribeNotifyMe($('#frmSubscribeNotify'));
		return false;
	});
	$(el('mainContainer')).on('submit','#frmSubscribeNotify',function(e)
	{
		e.preventDefault();

		subscribeNotifyMe($(el('frmSubscribeNotify')));
	});

	// Open popup with large image
	$('.product-img .fancybox').on('click',function()
	{
		if($(this).data('fancybox') == undefined)
		{
			var imageUrl = $(this).prop('href');
			var content = '<img class="popupProductImage" src="' + imageUrl + '" />';
			showFullScreenPopup(content,'','pdpModal');

			return false;
		}
	});

	preventNegativeValue();

	$('.input-quantity').keypress('change',function()
	{
		makePositiveValue();
	});

	$('.sizeGuideLink').on('click', function(){
		showCustomerPopup('sizeguide');

		return false;
	});

	$('.qtyBtn').click(function(e){
		e.preventDefault();

		var oEdtQty    = $(el('edtQty'));

		var iCurrentVal = parseInt(oEdtQty.val());
		var iMultiplier = parseInt(oEdtQty.data('qtyMultiplier'));
		var sType      = $(this).attr('data-type');

		if (!isNaN(iCurrentVal))
		{
			if(sType === 'minus')
			{
				if(iCurrentVal > oEdtQty.attr('min'))
				{
					oEdtQty.val(iCurrentVal - (1*iMultiplier)).change();
				}
			}
			else if(sType === 'plus')
			{
				oEdtQty.val(iCurrentVal + (1*iMultiplier)).change();
			}
		}
	});

	$(el('mainContainer')).on('click', '.downloadProductImage', function(e) {
		e.preventDefault();

		var sFileName= $(this).data('filename');
		downloadProductImage(sFileName);
	});

	// Show shop list on button click

	$(el('mainContainer')).on('click', '#showShops', function()
	{
		var shopList = $(el('storeList'));
		if (!$(el('storeList')).is(':visible'))
		{
			shopList.show(150);
		}
		else
		{
			shopList.hide(150);
		}
	});

	$(el('mainContainer')).on('click', '.askQuestion', function()
	{
		var sProductCode = $(this).data('productcode');
		var sUrl         = $(this).data('url');

		$(el('popupQuestion')).modal('show');

		$(el('askQuestionProductCode')).val(sProductCode);
		$(el('askQuestionType')).val('Product');
		$(el('askQuestionUrl')).val(sUrl);
	});

	$(el('mainContainer')).on('click', '.btn-add-bulk-tobasket', function()
	{
		var sSku = getSelectedSku();
		if(sSku)
		{
			var sCollectMethod = $(this).data('collectMethod');
			var sQuantity      = $(this).data('quantity');
			var sShopId        = $(this).data('shopId');
			var sShopStockId   = (typeof $(this).data('shopStockId') !== "undefined")?$(this).data('shopStockId'):sShopId;
			$(document).trigger( "addProduct",[sSku, sQuantity, sShopId, sCollectMethod, $(this).ajaxLoader('show'), 'hd']);

			addProduct(sSku, sQuantity, sShopId, sCollectMethod, $(this).ajaxLoader('show'), 'hd', undefined, false, sShopStockId);
		}
		return false;
	});

	$(el('mainContainer')).on('click', '#addToWishlist', function () {
		if (bEnableNewWishlist) {
			$(this).prop('disabled',true);
			addToWishlistPopup(oSelectedSizeData.value, $(this));
		} else {
			pdpAddToWishList();
		}
	});

	$(el('mainContainer')).on('click', '#removeFromWishlist', function () {
		if (bEnableNewWishlist) {
			$(this).prop('disabled',true);
			deleteLine($(this));
		} else {
			pdpRemoveFromWishlist();
		}
	});

	$(el('mainContainer')).on('show','#moreCcShops', function()
	{
		$('.toggleCcShops .icon-angle-down, .toggleCcShops .showMore').hide();
		$('.toggleCcShops .icon-angle-up, .toggleCcShops .showLess').show();
	});

	$(el('mainContainer')).on('hide','#moreCcShops', function()
	{
		$('.toggleCcShops .icon-angle-up, .toggleCcShops .showLess').hide();
		$('.toggleCcShops .icon-angle-down, .toggleCcShops .showMore').show();
	});

	// Variants
	$(el('mainContainer')).on("click", ".modelsFiltersContainer .filter-item", function () {
		handleVariantChange($(this));
	});

	$(el('mainContainer')).on("change", ".modelsFiltersContainer .filter .selectVariant", function () {
		$(".modelsFiltersContainer .filter .selectVariant").removeClass("chosen");
		$(this).addClass("chosen");

		switchVariant($(this), true);
	});

	if($(".initVersionEditionVariants").length > 0)
	{
		initVersionEditionVariants();
	}

	// Reviews
	$(el('mainContainer')).on("click", ".toggleCreateReviewModal", function () {
		$(el('createReviewModal')).modal('show');
		centerPopups();
	});

	$(el('mainContainer')).on("click", ".extendableList .addNeg, .extendableList .addPos", function (e) {

		e.preventDefault();
		addToExtendableList($(this));
	});

	$(el('mainContainer')).on("keyup blur", ".extendableListItemInput", function (e) {

		e.preventDefault();

		if($(this).val() === "")
		{
			var oList = $(this).closest('.extendableList');

			try
			{
				$(this).closest('.extendableListItem').remove();

				recountExtendableList(oList);
			}
			catch(err) {}
		}
	});

	$(el('mainContainer')).on("click", "#createReview", function (e) {

		e.preventDefault();

		clearErrors();

		var bValid = validateForm($(el('createReviewModal')));
		if (bValid)
		{
			var oCall = createReview();
			oCall.success(function(oData)
			{
				if(oData.errorType === "")
				{
					$('.toggleCreateReviewModal').hide();

					$(el('createReviewModal')).html('<div class="modal-header"><a href="##" data-dismiss="modal" aria-hidden="true" class="close">x</a><div class="clearfix"></div></div><div class="createReviewSuccess"><h2>' + tCreateReviewSuccess + '</h2></div>');
					centerPopups();

					setTimeout(function()
					{
						$(el('createReviewModal')).modal('hide');
					}, 4000);
				}
				else
				{
					// show error message
					showAlert('error', oData.errorMessage, oData.errorUnhandled);
				}
			});
		}
	});

	$(el('mainContainer')).on("change", ".extendableList .checkbox-input input[type='checkbox']", function (e) {

		e.preventDefault();
		$(this).parents('.extendableListItem').find('input[type="text"]').prop('disabled', !$(this).is(':checked'));
	});

	$(el('mainContainer')).on("click", ".showInitHidden", function (e) {

		e.preventDefault();

		$('.entry-container.init-hidden').show();
		$('.product-reviews-entries-all').show();
		$(this).remove();
	});

	$(el('mainContainer')).on("click", ".getAllReviewEntries", function (e) {

		e.preventDefault();

		var nextPage = $(this).data('nextPage');
		var oBtn     = $(this);

		var oCall = getReviews(nextPage);
		oCall.success(function(oData)
		{
			if(oData.errorType === "" && oData.html !== "")
			{
				oBtn.remove();
				$('.product-reviews-entries').append(oData.html);
			}
			else
			{
				// show error message
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
			}
		});
	});

	$(el('mainContainer')).on("click", ".anchorReviews", function (e) {

		e.preventDefault();

		scrollToElement($('.product-reviews:visible'));
	});

	$(el('mainContainer')).on("click", ".entry-description-read-all", function (e) {

		e.preventDefault();

		$(this).hide();
		$(this).parents('.entry-container').find('.entry-description-sliced').addClass('showAll');
		$(this).parents('.entry-container').find('.entry-description-read-less').show();
	});

	$(el('mainContainer')).on("click", ".entry-description-read-less", function (e) {

		e.preventDefault();

		$(this).hide();
		$(this).parents('.entry-container').find('.entry-description-sliced').removeClass('showAll');
		$(this).parents('.entry-container').find('.entry-description-read-all').show();
	});



	$(el('mainContainer')).on("click", ".listingCta", function (e)
	{
		e.preventDefault();

		if(iCustomerId !== -1)
		{
			var sListingType   = $(this).data('listingType');
			var sListingAction = $(this).data('action');

			var oCall = setListing(sListingType,sListingAction);
			oCall.success(function(oData)
			{
				if(oData.errorType === "")
				{
					$(".listingCta").hide();
					if(sListingAction === "remove")
					{
						$('.listingCta[data-listing-type="collection"][data-action="add"]').show();
						$('.listingCta[data-listing-type="wishlist"][data-action="add"]').show();
					}
					else
					{
						if(sListingAction === "move")
						{
							var sInvertListingType = (sListingType === "wishlist")?"collection":"wishlist";
							$('.listingCta[data-listing-type="' + sInvertListingType + '"][data-action="move"]').show();
							$('.listingCta[data-listing-type="' + sListingType + '"][data-action="remove"]').show();
						}
						else if(sListingAction === "add")
						{
							var sInvertListingType = (sListingType === "wishlist")?"collection":"wishlist";
							$('.listingCta[data-listing-type="' + sInvertListingType + '"][data-action="move"]').show();
							$('.listingCta[data-listing-type="' + sListingType + '"][data-action="remove"]').show();
						}
					}
				}
				else if(oData.errorType === 'expired')
				{
					location.reload(true);
				}
				else
				{
					// show error message
					showAlert('error', oData.errorMessage, oData.errorUnhandled);
				}
			});
		}
		else
		{
			window.location = '/' + sCurrentLanguageCode + '/customer/login'
		}
	});

	$(el('mainContainer')).on("click", ".reservationContainer .btnCancel", function (e) {
		$(".reservationContainer").addClass("hidden");
		$(".shopselectionContainer").removeClass("hidden");
		return false;
	});
	$(el('mainContainer')).on("click", ".reservationContainer .edit", function (e) {
		$("#frmReservation .hidden").removeClass("hidden");
		$("#frmReservation .customerData").addClass("hidden");
		return false;
	});
	$(el('mainContainer')).on("click", ".reservationContainer .btnCloseReserved", function (e) {
		$(".reservationContainer").addClass("hidden");
		$(".shopselectionContainer").removeClass("hidden");
		$("#ccShops").addClass("hidden");

		// reload shops
		var sPostalCode = $(el('edtPostalcode')).val();
		findShops(sPostalCode);

		return false;
	});

	// Notify me
	$(el('mainContainer')).on("click", "#btnNotifyMe", function (e) {
		// Add event to hide popover when clicking anywhere
		function onWindowClick() {
			$("#btnNotifyMe").popover('hide');
			// remove the event
			$('#mainContainer').off('click', onWindowClick);
		}
		if (sCustomerId != "-1") {
			// Do call
			notifyMe($(this).data("remove"));
		} else {
			if (!bGuestNotifyMeProductRegister) {
				// Show login popover if guest notify me is OFF
				$("#btnNotifyMe").popover({
					html: true,
					placement: 'bottom',
					title: "",
					content: "<p>" + tNotifyMeText + "</p><a class='btnNotifyMePopover' href='/nl/customer/login'><i class='fal fa-lock'></i>" + tNotifyMeCreateAccount + "</a>"
				}).popover('show');
			} else if (iCustomerId === -1 && bGuestNotifyMeProductRegister) {
				// Show modal if guest notify me is ON
				var oPopup = $('#notifyMeRegisterModal');
				oPopup.modal("show");
			}
		}
		  // add the event
		  $('#mainContainer').on('click', onWindowClick);
	});

	$(el('mainContainer')).on("change", ".addonSelector select", function()
	{
		var oSelectedOption = $(this).find("option:selected");
		var selectedOptionValue = oSelectedOption.val();
		var oWrapper = $(this).parents(".addonSelector");

		if (selectedOptionValue === ""){
			oWrapper.find('.addonPrice').html(" ");
		}
		else{
			if(typeof oSelectedOption.data("price") !== "undefined" && oSelectedOption.data("price") !== "")
				{
					oWrapper.find('.addonPrice').html("(+" + oSelectedOption.data("price") + ")")
				}
		}
	});

	$(el('mainContainer')).on("click", ".relatedProductsLayouts .relatedProductsLayout", function()
	{
		$(".relatedProductsLayouts .relatedProductsLayout").removeClass("active");
		$(this).addClass("active");

		var oFlexslider = $(".detailRelated .flexslider");
		oFlexslider.find(".slides").unwrap();
		oFlexslider.find(".flex-direction-nav").remove();
		oFlexslider.removeData("flexslider");

		if(window.innerWidth > 1199)
		{
			oFlexslider.data("item-count-desktop",$(this).data("count"));
		}
		else if(window.innerWidth > 978 && window.innerWidth <= 1199)
		{
			oFlexslider.data("item-count-tablet-l",$(this).data("count"));
		}
		else if(window.innerWidth >= 768 && window.innerWidth <= 978)
		{
			oFlexslider.data("item-count-tablet-p",$(this).data("count"));
		}
		else if(window.innerWidth < 768)
		{
			oFlexslider.data("item-count-mobile",$(this).data("count"));
		}

		if(oFlexslider.length > 0)
		{
			if(oFlexslider.hasClass('responsive'))
			{
				var iInnerWidth = $('.detailRelated').innerWidth();

				setSlider(oFlexslider, iInnerWidth);
			}
		}
	});

	// init detail page
	init();
});


function addToWishlistPopup(sSkuId, oBtn)
{
	uAjax = "/index.cfm/wishlist/ajax/addToWishlistPopup";

	var sParams = '&skuid=' + sSkuId;
	var oCall = callAjax("addToWishlistPopup", sParams, "post");
	oCall.success(function(oData)
	{
		if (oData.errorType == '')
		{
			var oWishlistModal = oData.html;

			$('#addProductWishlistPopup').html(oWishlistModal);
			$('#addProductWishlistPopup .modal').modal('show');
		} else if (oData.errorType == 'product_added') {
			$("#mainContainer header .wishlistWrapper").replaceWith(oData.headerLinksHtml);
			$(el("addToWishlist")).replaceWith('<i class="fa fa-heart icon-heart" id="removeFromWishlist"></i>');
			$("#mainContainer header").append(oData.productAddedDropdown);
			$("#mainContainer header .wishlistProductDropdown").css('animation','pulse 2s 3');
			$("#mainContainer header .wishlistProductDropdown").hide().fadeIn(500).delay(5000).fadeOut(500, function(){
				$(this).remove();
			});
		}
		else if (oData.errorType == 'not_logged_in') {
			window.location = '/' + sCurrentLanguageCode + '/customer/login'
		} else {
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
		oBtn.prop('disabled',false);
	});
}

function subscribeNotifyMe(frmSubscribeNotify) {
	clearErrors();
	$('.emailNotifyMeForm #btnSubscribeRegisterNotify').prop('disabled', true)
	var bValid = validateForm(frmSubscribeNotify);
	if (bValid) {
		var sEmail = $('#inputEmailSubscribeNotify').val();

		uAjax = "/index.cfm/customer/ajax/subscribeNotifyMe";
		var sParams = '&sEmail=' + sEmail + '&sSkuId=' + oSelectedSizeData.value;
		var oCall = callAjax('subscribeNotifyMe', sParams, 'post');
		oCall.success(function(oData) {
			if (oData.errorType != '')
			{
				$('.emailNotifyMeForm .notifyMeSubText').text(oData.errorMessage);
				$('.emailNotifyMeForm #btnSubscribeRegisterNotify').prop('disabled', false)
			}
			else
			{
				$(document).trigger("subscribeNotifyMe",[sEmail]);
				$('#frmSubscribeNotify input[type="text"]').val('');
				$('.emailNotifyMeForm .notifyMeSubscribeSubText').text(tNotifyMeRegisterSubscribed);
				$('.emailNotifyMeForm #btnSubscribeRegisterNotify').hide();
				setTimeout(function() { $('#notifyMeRegisterModal').modal("hide"); }, 5000);
			}
		});
	}
	else
	{
		showAlert('error', tSubscribeInvalidInput, false);
		$('.emailNotifyMeForm #btnSubscribeRegisterNotify').prop('disabled', false);
	}
}

function notifyMe(remove) {
	var endpoint = "notifyme";
	if (remove) endpoint = "deletenotifyme";

	uAjax = '/index.cfm/product/ajax/' + endpoint;
	var sParams = '&skuId=' + oSelectedSizeData.value;
	var oCall = callAjax(endpoint, sParams, "post");
	oCall.success(function (oData)
	{
		if (oData.errorType == '') {
			$("#btnNotifyMe .btnText").text(remove ? tNotifyMeBtn : tNotifyMeSubscribed);
			$("#btnNotifyMe").data("remove", !remove);
			showAlert("info", remove ? tNotifyMeAlertNotSubscribed : tNotifyMeAlertSubscribed, false, 3000);
			if (remove) {
				notifymeproducts = notifymeproducts.filter(function(item) {
					return item !== oSelectedSizeData.value
				})
			} else {
				notifymeproducts.push(oSelectedSizeData.value);
			}
		}
		else {
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function setListing(sListingType,sListingAction)
{
	uAjax = '/index.cfm/product/ajax/setlistingproduct';
	var sParams = '&listingType=' + sListingType + '&listingAction=' + sListingAction + '&productId=' + sOriginalProductId;

	return oCall   = callAjax("getreviews", sParams, "post");
}

function getReviews(nextPage)
{
	uAjax = '/index.cfm/product/ajax/getreviews';

	var sParams = '&productId=' + sOriginalProductId + '&page=' + nextPage;

	return oCall   = callAjax("getreviews", sParams, "post");
}
function createReview()
{
	uAjax = '/index.cfm/product/ajax/createreview';

	var sParams = getValues($(el('createReviewModal')));

	return oCall   = callAjax("createreview", sParams, "post");
}

function recountExtendableList(oList)
{
	var iCount  = oList.find('.extendableListItem').length;

	oList.find('.extendableListItem').each(function()
	{
		iCount--;
		var type = $(this).data('type');

		$(this).css('order',iCount);
		$(this).find('.checkbox-input input[type="checkbox"]').attr('id','inputBox'+type+iCount);
		$(this).find('.checkbox-input label').attr('for','inputBox'+type+iCount);
		$(this).find('input[type="text"]').attr('id','input'+type+iCount);
	});

	if(iCount < 3)
	{
		oList.find('.addPos,addNeg').show();
	}
}

function addToExtendableList(oBtn)
{

	var oExtendableList = oBtn.closest('.extendableList');
	var iCount= oExtendableList.find('.extendableListItem').length;
	var sType = (oBtn.hasClass('addNeg'))?'Negatives':'Positives';

	var sLi = '<li data-type="' + sType + '" class="extendableListItem" style="order:' + iCount + '"><span class="checkbox-input"><input type="checkbox" id="inputBox' + sType + iCount + '" checked="checked"><label for="inputBox' + sType + iCount + '"></label></span><input type="text" id="input' + sType +iCount+'" name="input' + sType + '" class="extendableListItemInput" maxlength="50"></li>';

	oExtendableList.prepend(sLi);

	$('#input' + sType +iCount).focus();

	(oExtendableList.find('.extendableListItem').length == 3) ? oBtn.hide():oBtn.show();
}

function handleVariantChange(oFilterItem)
{
	var oFilter = oFilterItem.closest('.select');
	oFilter.find('.filter-item').removeClass('selected');
	oFilterItem.addClass('selected');
	oFilter.addClass("chosen");

	switchVariant(oFilter, false);
}

function switchVariant(target, isSelect, isRetry) {
	if (typeof isRetry === "undefined") isRetry = false;

	if(isRetry)
	{
		// check if retries equal the amount of available options
		if($(".selectVariant:not('.chosen') option:not(.defaultSelected)").length > $(".selectVariant:not('.chosen') option.tried").length)
		{
			isRetry = false;
		}
	}

	var filters = [];
	target.closest(".modelsFiltersContainer").find(".filter").each(function () {
		if (isSelect) {
			var select = $(this).find(".selectVariant");
			var selectedFilter = select.val();
			filters.push({ "featureId": select.prop("id"), "featureListItemId": selectedFilter });
		}
		else {
			var select = $(this).find(".select");
			var selectedFilter = select.find('.filter-item.selected').attr('value');
			filters.push({ "featureId": select.prop("id"), "featureListItemId": selectedFilter });
		}
	});

	uAjax = "/index.cfm/product/ajax/getproductvariantbyfeatures";
	var oCall = callAjax("getproductvariantbyfeatures", { "filters": filters, "productId": sProductId }, "post");
	oCall.success(function (oData) {
		if (typeof oData.url !== "undefined" && oData.url !== "") {
			window.location = oData.url.toLowerCase();
		} else if (!isRetry) {
			// Check other combo
			var oFirstUnUsedOption = $(".selectVariant:not('.chosen') option:not(:selected)").not(".tried,.defaultSelected").first();
			oFirstUnUsedOption.attr('selected', 'selected');
			oFirstUnUsedOption.addClass("tried");
			$(".selectVariant:not('.chosen') option:selected").attr('selected', '');
			switchVariant($(".selectVariant:not('.chosen')"), true, true);
		}
	});
};

function pdpAddToWishList() {
	uAjax = "/index.cfm/customer/ajax/addtowishlist";

	// Set loader
	var sParams = '&productId=' + sOriginalProductId;

	var oCall = callAjax("addToWishlist", sParams, "post");

	// process feedback
	oCall.success(function (oData) {
		var value = (parseFloat(oSelectedSizeData.pricePromo.replace("€","").replace(",",".").trim()) != 0) ? parseFloat(oSelectedSizeData.pricePromo.replace("€","").replace(",",".").trim()) : parseFloat(oSelectedSizeData.price.replace("€","").replace(",",".").trim());
		$(document).trigger( "addToWishlist", sOriginalProductId, sWebName,value);

		$(el("addToWishlist")).replaceWith('<i class="fa fa-heart icon-heart" id="removeFromWishlist"></i>');

		if($('.wishlistQuantity').length > 0)
		{
			$('.wishlistQuantity').html('<span>'+oData.wishlistQuantity+'</span>');
			if(oData.wishlistQuantity == 0)
			{
				$('.wishlistQuantity').hide();
			}
			else
			{
				$('.wishlistQuantity').show();
				$('.wishlistQuantity span').css('animation','pulse 2s 3');
			}
		}
	});
}

function pdpRemoveFromWishlist() {
	uAjax = "/index.cfm/customer/ajax/removefromwishlist";

	// Set loader
	var sParams = '&productId=' + sOriginalProductId;

	var oCall = callAjax("removeFromWishlist", sParams, "post");

	// process feedback
	oCall.success(function (oData) {
		$(el("removeFromWishlist")).replaceWith('<i class="fa fa-heart-o icon-heart-empty" id="addToWishlist"></i>');

		if($('.wishlistQuantity').length > 0)
		{
			$('.wishlistQuantity').html('<span>'+oData.wishlistQuantity+'</span>');
			if(oData.wishlistQuantity == 0)
			{
				$('.wishlistQuantity').hide();
			}
			else
			{
				$('.wishlistQuantity').show();
			}
		}
	});
}

function loadCCReservationForm(shopId) {
	uAjax = "/index.cfm/product/ajax/loadccreservation";

	// Set loader
	$(".shopselectionContainer").addClass("hidden");
	$(".reservationContainer").removeClass("hidden");


	var sParams = "&shopId=" + shopId;
	var oCall = callAjax("loadccreservation", sParams, "post");
	// process feedback
	oCall.success(function (oData) {
		if (oData.errorType == '') {
			$(".reservationContainer").html(oData.html);
			if(!bUseValidationServiceForPhoneFields)
			{
				// phone numbers
				$(".reservationContainer input[data-type='phone']").inputmask('Regex', {regex: rPhone});
			}
		}
		else {
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
};

function addProduct(sSku, iQty, sShopId, sCollectMethodId, oLoader, sCollectMethodCode, sPointId, reserveNow, sShopStockId)
{
	var valid = true;
	if (typeof $("#btnAddProduct").data('tadaazCustomizable') !== "undefined") {
		var bTadaazIsCustomizable = $("#btnAddProduct").data('tadaazCustomizable');

		if(!bTadaazIsCustomizable)
		{
			var iSkuQty          = getSkuQty();
			var sSelectedSku     = getSelectedSku();

			if(sSelectedSku && iSkuQty > 0)
			{

				var oCall = addTadaazEntryToBasket(sSelectedSku, iSkuQty, sCollectMethodId, sShopId, sShopId);

				oCall.success(function (oData)
				{
					if (oData.ErrorType !== "")
					{
						showAlert('error', oData.ErrorMessage, oData.Unhandled);
					}
					else
					{
						window.location = uTransaction;
					}
				});
			}
		}
	}
	else
	{
		var bTadaazIsCustomizable = true;
	}

	if (reserveNow) {
		valid = validateForm($('#frmReservation'));

		if (!valid)
		{
			$("#ccShops .btnReserve").find("i").removeClass().addClass("fal fa-check");
			$("#ccShops .btnReserve").prop("disabled",false);
		}
	}

	if (valid) {
		uAjax = "/index.cfm/transaction/ajax/addsku";

		//disable button
		oLoader.prop('disabled', true);

		if (typeof sConfigurator !== "undefined" && sConfigurator !== "") {
			if (sConfigurator === "vanhalst" || (sConfigurator.toLowerCase() === "tadaaz" && sConfiguratorCode !== "" && bTadaazIsCustomizable)) {
				window.location = "/" + uConfiguratorExternal + sConfiguratorHashed + "/" + sConfiguratorCodeHashed + "?skuId=" + sSku;
				return false;
			}
		}

		// Set loader
		var sParams = '&skuId=' + sSku
			+ '&qty=' + iQty
			+ '&collectMethod=' + sCollectMethodCode
			+ '&collectMethodId=' + sCollectMethodId
			+ '&idShop=' + sShopId
			+ '&productId=' + sProductId
			+ '&bMobile=' + (screenWidth < 768)
			+ '&listingId=' + sListingId
			+ '&combined=' + bCombined;
		if (sPointId) sParams += '&pointId=' + sPointId;

		if (reserveNow) {
			sParams += "&reservenow=" + reserveNow;

			// Get form address data
			var frmData = $("#frmReservation").serialize();
			sParams += '&' + frmData;
		}
		if (bPreorder) sParams += "&preorder=" + bPreorder;
		if (typeof sShopStockId !== "undefined")  sParams += "&shopStockId=" + sShopStockId;

		var oCall = callAjax("addSku", sParams, "post");
		// process feedback
		oCall.success(function (oData) {
			if (oData.errorType == '') {

				// Add to basket successful
				if (typeof sConfigurator !== "undefined" && sConfigurator !== "" && sConfigurator === "print") {
					// Go to location
					window.location = "/" + uConfigurator + sConfigurator + "/" + sConfiguratorCode;
				}
				if (reserveNow) {
					$("#ccShops .reservationContainer").html(oData.html);
				} else if (typeof sConfigurator == "undefined" || sConfigurator == "" || sConfigurator == "intersolve_voucher" || sConfigurator.toLowerCase() == "dropshipment" || sConfigurator == "Marketplace" || (sConfigurator.toLowerCase() === "tadaaz" && (sConfiguratorCode == "" || !bTadaazIsCustomizable))) {
					// handle button states
					setButtonStates(oData.collectMethodsUsed);
					triggerBasketAction(oData);
				}
				if (window.history && window.history.pushState)
				{
					window.history.pushState({"addedProductToBasket": true}, "addedProductToBasket", location.href);
				}
			}
			else {
				// show error message
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
			}

			// Hide loader
			oLoader.ajaxLoader('hide');

			//reenable button
			oLoader.prop('disabled', false);
		});
	}
}

function addConfiguration(sCollectMethodId, sShopId, bReserveNow, sAddons,sMainSkuId, sMainSkuQty, oLoader, bShopdefaultForConfiguration)
{
	var valid = true;
	if (bReserveNow) {
		valid = validateForm($('#frmReservation'));
	}

	if (valid) {
		uAjax = "/index.cfm/transaction/ajax/addconfiguration";

		var sParams = '&collectMethodId=' + sCollectMethodId
					+ '&addons=' + encodeURIComponent(sAddons)
					+ '&mainSkuId=' + sMainSkuId
					+ '&mainSkuQty=' + sMainSkuQty
					+ '&shopId=' + sShopId
					+ '&productId=' + sProductId
					+ '&reserveNow=' + bReserveNow
					+ '&bMobile=' + (screenWidth < 768);

		if (bReserveNow) {
			// Get form address data
			var frmData = $("#frmReservation").serialize();
			sParams += '&' + frmData;
		}
		if (bPreorder) sParams += "&preorder=" + bPreorder;
		if (typeof bShopdefaultForConfiguration !== "undefined")  sParams += "&shopdefaultForConfiguration=" + bShopdefaultForConfiguration;

		if($(".addons").length > 0 && typeof $(".addons").data("recalc") !== "undefined")
		{
			sParams += "&recalc=" + ($(".addons").data("recalc") == true);

			if(typeof $(".addons").data("recalcFactor") !== "undefined")
			{
				sParams += "&recalcFactor=" + $(".addons").data("recalcFactor");
			}
		}

		var oCall = callAjax("addConfiguration", sParams, "post");
		oCall.success(function(oData){

			// Hide loader
			oLoader.ajaxLoader('hide');
			if(oData.errorType == '')
			{
				if (bReserveNow) {
					$("#ccShops .reservationContainer").html(oData.html);
				}
				else{
					$('.addons').find('input,select').not(':button, :submit, :reset, :hidden, :checkbox, :radio').val('').prop('disabled',false);
					$('.addons').find('checkbox,radio').prop('checked', false);

					if (typeof sConfigurator == "undefined" || sConfigurator == "" || sConfigurator == "intersolve_voucher") {
						// handle button states
						setButtonStates(oData.collectMethodsUsed);
						triggerBasketAction(oData);
					}
					if (window.history && window.history.pushState)
					{
						window.history.pushState({"addedProductToBasket": true}, "addedProductToBasket", location.href);
					}
				}
			}
			else
			{
				// show error message
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
			}
		});
	}
}

function addToCustomerProductList(sId, sSku, iQty, sShopId, oLoader)
{
	uAjax = "/index.cfm/product/ajax/addtocustomerproductlist";

	// Set loader
	var sParams = '&id=' + sId
				+ '&skuId=' + sSku
				+ '&qty=' + iQty
				+ '&idShop=' + sShopId;

	var oCall = callAjax("addToCustomerProductList", sParams, "post");
	// process feedback
	oCall.success(function(oData)
	{
		if(oData.errorMessage === 'Inserted.')
		{
			$('.pdpCustomerProductLists').modal('hide');

			// show success message
			showAlert('warning', tAddedToCustomerProductList, oData.errorUnhandled);

			// append skuId
			var oCustomerProductList = $('.customerProductListSelectors').find('.customerProductListSelector[data-id="' + sId + '"]');
			var sSkuSet              = oCustomerProductList.data('skus');
			var sSkus                = sSkuSet + ',' + sSku;

			oCustomerProductList.attr('data-skus', sSkus);
		}
		else
		{
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}

		// Hide loader
		oLoader.ajaxLoader('hide');
	});
}

function addTadaazEntryToBasket(sSelectedSku, iSkuQty, sCollectMethodId, sShopHandlingId, sShopStockId)
{
	oData                        = {};
	oData.config                 = {};
	oData.config.type            = sConfigurator; // "tadaaz"
	oData.config.code            = sConfiguratorCode; // tadaazTemplateId
	oData.config.userToken       = sTadaazUserToken; //tadaazUserToken
	oData.config.collectMethodId = sCollectMethodId;
	oData.config.shopHandlingId  = sShopHandlingId;
	oData.config.shopStockId     = sShopStockId;
	oData.config.lines           = getSelectedAddons(true);
	oData.mainSkuId              = sSelectedSku;
	oData.mainSkuQty             = iSkuQty;

	mainSku             = {};
	mainSku.skuId       = sSelectedSku;
	mainSku.quantity    = iSkuQty;
	mainSku.sample      = false; // tadaazIsSample
	mainSku.description = sWebName;
	mainSku.entryId     = ""

	if(!bOneColourOneSize)
	{
		var size   = $('.size-item.selected').text().replace('\t', '');
		var colour = $('.swatch-item.selected img').prop('title').replace(/\t+/g, "");
		mainSku.description += " " + colour + " " + size;
	}
	oData.config.lines.push(mainSku);

	return callAjax("saveexternalconfiguration", oData, "post", "/index.cfm/product/ajax/externalconfig/save");
}

function changeColour(sColour)
{
	// show correct product images
	if(sColour != "-1")
	{
		showProductImages(sColour);
	}
}

function checkMultiplier(qtyInput)
{

	var qty = qtyInput.val();
	var multiplier = qtyInput.data('qtyMultiplier');

	if(typeof qtyInput.data('min') !== 'undefined')
	{
		var minQty = parseInt(qtyInput.data('min'));
		if(qty < minQty)
		{
			qty = minQty;
			qtyInput.val(qty);
		}
	}
	if(multiplier > 1)
	{
		if(qty < multiplier)
		{
			qtyInput.val(multiplier);
		}
		else
		{
			var diffQty = (qty % multiplier);
			if(diffQty !== 0)
			{
				var newQty = Math.ceil(qty/multiplier) * multiplier;
				qtyInput.val(newQty);
			}
		}
	}
}

function checkOneSize()
{
	// Check if one size and select it
	if($('.selectSizes:visible').children('option').length === 2)
	{
		$('.selectSizes:visible option').filter(function()
		{
			//may want to use $.trim in here
			return $(this).val() != -1;
		}).prop('selected', true);
	}
}

function downloadProductImage(sFileName)
{
	$('body').append(
	    $('<iframe>', {
	        src: '/product/downloadProductImage?filename=' + sFileName
	    }).hide()
	);
}

function initCCshops()
{
	var bHasShopWithStockForCC = false;

	$('.click-collect').removeClass("hidden");
	$(el('ccShops')).find('.shop').each(function()
	{
		if((parseInt($(this).data('stock')) > 0 || $(this).data('ccavailable')) && (!oSelectedSizeData.emptyPrice || bPreorder))
		{
			if ($(this).hasClass("stockhd")) {
				$(this).find('.stock,.ccDeliveryPromise').html(sCcUnavailableAvailableHd);
			} else {
				$(this).find('.ccDeliveryPromise').html(sCcAvailable);
			}
			bHasShopWithStockForCC = true;
		}
		else
		{
			var bDisabled =  getDisabledDataOnSelectedSize();
			if(bDisabled)
			{
				$(this).find('.ccDeliveryPromise').html(sHdUnavailablePreorder);
				$(this).hide();

				if($(el('ccShops')).find('.shop:not([style*="display: none"])').length === 0)
				{
					$('.click-collect').addClass("hidden");
				}
				else
				{
					$('.click-collect').removeClass("hidden");
				}
			}
			else
			{
				$(this).find('.ccDeliveryPromise').html(sCcUnavailable);
			}
		}
	});

	var ccMethod   = (typeof $('#btnAddProduct').data('clickcollectMethod') !== "undefined")?$('#btnAddProduct').data('clickcollectMethod'):'';
	if (bHasShopWithStockForCC) {
		$(el('mainContainer')).find('.deliveryPromiseShopStockCC').removeClass('hidden');
		$(el('mainContainer')).find('#btnShowClickCollect').removeClass('disabled').prop("disabled", false);
		$(el('mainContainer')).find('#btnShowClickCollectBottomTrigger').removeClass('disabled').prop("disabled", false);
		if (bDoNotDisplayHDBlockedOnPDP && ccMethod !== '') {
			$('#btnAddProduct').attr('data-collect-method', ccMethod);
		}
	}
	else {
		$(el('mainContainer')).find('.deliveryPromiseShopNoStockCC').removeClass('hidden');
		$(el('mainContainer')).find('#btnShowClickCollect').addClass('disabled').prop("disabled", true);
		$(el('mainContainer')).find('#btnShowClickCollectBottomTrigger').addClass('disabled').prop("disabled", true);
		if (bDoNotDisplayHDBlockedOnPDP && ccMethod !== '') {
			$('#btnAddProduct').attr('data-collect-method', $('#btnAddProduct').data('hdMethod'));
		}
	}

	if(oSelectedSizeData.disabled)
	{
		(bHasShopWithStockForCC) ? $(el('mainContainer')).find('.productData').addClass('hasShopWithStockForCC') : $(el('mainContainer')).find('.productData').removeClass('hasShopWithStockForCC');
	}
	else
	{
		$(el('mainContainer')).find('.productData').removeClass('hasShopWithStockForCC');
	}
}

function getDisabledDataOnSelectedSize()
{
	var bAllowHd = (bPreorder) ? bProductAllowHDPreOrder : bProductAllowHD;
	if(bAllowHd)
	{
		var bDisabled = oSelectedSizeData.disabled;
	}
	else
	{
		// Check overrides
		var oProductOverrides = JSON.parse(sProductOverrides);
		var oOverride = oProductOverrides.find(override => override.skuId == oSelectedSizeData.value);
		var bDisabled = (typeof oOverride !== "undefined") ? !oOverride.canOrderOriginal : false;
	}

	return bDisabled;
}

function getNotifyButton()
{
	// Check notify me button
	var btnNotify        = $("#btnNotifyMe");
	var btnNotifyTrigger = $("#btnNotifyMeTrigger");
	var bDisabled        = getDisabledDataOnSelectedSize();

	if(!bIsUsedProduct && (bDisabled || oSelectedSizeData.emptyPrice))
	{
		if (btnNotify.length > 0 && !oSelectedSizeData.endoflife) {
			if(bDisabled)
			{
				// reset canOrderCC class
				$(".size-item[data-value=" + oSelectedSizeData.value + "]").removeClass("canOrderCC");
			}
			// Set buy button hidden and notifyme button visble
			$('#btnAddProduct, #btnAddProductBottomTrigger, #edtQty, .btnIsHomeDelivery, .qtyBtn, .product-inputs .edtQtyWrapper').addClass("hidden");
			btnNotify.removeClass("hidden");
			btnNotifyTrigger.removeClass("hidden");
			$(el('mainContainer')).find('.productData').addClass('hasNotifyMe');
		}
	} else if (btnNotify.length > 0 && !notifymeproducts.includes(oSelectedSizeData.value)) {
		btnNotify.addClass("hidden");
		btnNotifyTrigger.addClass("hidden");
		$('#btnAddProduct, #btnAddProductBottomTrigger, #edtQty, .btnIsHomeDelivery, .qtyBtn, .product-inputs .edtQtyWrapper').removeClass("hidden");
		$(el('mainContainer')).find('.productData').removeClass('hasNotifyMe');
	}
	checkNotifyMe();
}

function handleGeolocateCCshops(oLookup)
{
	loadCCShops(oSelectedSizeData.value,oLookup.results[0].geometry.location.lat(),oLookup.results[0].geometry.location.lng());
}
function loadCCShops(sSelectedSku,sLat,sLong)
{
	if(bLoadCollectInAdvance == 1)
		{
			// load without lookup
			uAjax = "/index.cfm/product/ajax/collect";
			var oLoader = $(el('btnShopLookup')).parent();
			oLoader.ajaxLoader('show');

			var qty = $(el('edtQty')).val();
			if(qty > 9999)
			{
				qty = 9999;
			}

			var sParams = '&skuId=' + sSelectedSku
				+ '&qty=' + qty
				+ '&sLat=' + sLat
				+ '&sLong=' + sLong
				+ '&productId=' + sProductId
				+ '&preorder=' + bPreorder
				+ '&preorderStock=' + bPreorderStock
				+ '&combined=' + bCombined
				+ '&isUsedProduct=' + bIsUsedProduct;
			if (typeof bCcShowWithoutStock !== "undefined") {
				sParams += "&showWithoutStock=" + bCcShowWithoutStock;
			}
			var oCall = callAjax("collect", sParams, "post");

			// process feedback
			oCall.success(function(oData)
			{
				$('.click-collect').show();
				bShopsLookedUp = true;

				$(el('ccShopsContainer')).html(oData.html);

				// Display none ccShops element if result comes blank (blank is \r\n so used regex to check)
				if ($(el('mainContainer')).find('.ccShopsRemoval').length > 0 && oData.html.replace(/^\s*\n/gm, "") === "" && oData.errorType === '') {
					$(el('mainContainer')).find('.ccShopsRemoval').hide();
				} else if ($(el('mainContainer')).find('.ccShopsRemoval').length > 0) {
					$(el('mainContainer')).find('.ccShopsRemoval').show();
				}
				if (typeof bCcShowWithoutStock !== "undefined" && bCcShowWithoutStock) {
					$(el('mainContainer')).find('.ccDeliveryPromise').html(sCcAvailable);
				}

				if(bPreorder)
				{
					if(bProductAllowCCPreOrder)
					{
						initCCshops();
					}
					else
					{
						$(".disableCCDeliveryPromise").html(sDeliveryPromiseDisableCCPreOrder);
						$(el('ccShopsContainer')).addClass('disabled').prop("disabled", true).hide();
						$(el('showShops')).addClass('disabled').prop("disabled", true).hide();
					}
				}
				else
				{
					if(bProductAllowCC)
					{
						initCCshops();
					}
					else
					{
						$(".disableCCDeliveryPromise").html(sDeliveryPromiseDisableCC);
						$(el('ccShopsContainer')).addClass('disabled').prop("disabled", true).hide();
						$(el('showShops')).addClass('disabled').prop("disabled", true).hide();
					}
				}

				getNotifyButton();

				if (typeof customCollectCallback  !== "undefined") {
					customCollectCallback();
				}

				// Hide loader
				oLoader.ajaxLoader('hide');
			});

	}
	else
	{
		uAjax = "/index.cfm/product/ajax/collect";

		// Clear previous errors
		clearErrors();

		// show loader
		var oLoader = $(el('btnShopLookup')).parent();
		oLoader.ajaxLoader('show');

		var qty = $(el('edtQty')).val();
		if(qty > 9999)
		{
			qty = 9999;
		}

		var sParams = '&skuId=' + sSelectedSku
			+ '&qty=' + qty
			+ '&sLat=' + sLat
			+ '&sLong=' + sLong
			+ '&productId=' + sProductId;
		var oCall = callAjax("collect", sParams, "post");

		// process feedback
		oCall.success(function(oData)
		{
			$('.click-collect').show();
			bShopsLookedUp = true;
			$(el('ccShopsContainer')).hide().html(oData.html).slideDown(300);

			if(bPreorder)
			{
				if(bProductAllowCCPreOrder)
				{
					initCCshops();
				}
				else
				{
					$(".disableCCDeliveryPromise").html(sDeliveryPromiseDisableCCPreOrder);
				}
			}
			else
			{
				if(bProductAllowCC)
				{
					initCCshops();
				}
				else
				{
					$(".disableCCDeliveryPromise").html(sDeliveryPromiseDisableCC);
				}
			}

			getNotifyButton();

			if (typeof customCollectCallback  !== "undefined") {
				customCollectCallback();
			}

			// Hide loader
			oLoader.ajaxLoader('hide');
		});
	}
}
function findShops(postalCode)
{
	if(oSelectedSizeData.value != '-1' && typeof oSelectedSizeData.value !== 'undefined')
	{
		if(typeof postalCode !== "undefined" && postalCode !== "")
		{
			geoLookup(postalCode,undefined,handleGeolocateCCshops,undefined);
		}
		else
		{
			loadCCShops(oSelectedSizeData.value,"","");
		}
	}
	else
	{
		bShopsLookedUp = true;
	}
}

function disableQtyEdit()
{
	if(bSerialNumberSale && bSellUnique)
	{
		$(el('edtQty')).prop('disabled', true);
		$('.qtyBtn').prop('disabled', true);
	}
}

function getBulkPrices()
{
	var sSkuId = oSelectedSizeData.value;
	var bDisabled = oSelectedSizeData.disabled;

	if(typeof aQuantities !== 'undefined' && aQuantities !== '' && sSkuId != "-1")
	{
		uAjax = "/index.cfm/product/ajax/bulkprices";

		// Set loader
		var sParams = '&skuId=' + sSkuId
					+ '&quantities=' + aQuantities
					+ '&productId=' + sProductId
					+ '&disabled=' + bDisabled;
		if($('.bulkUnitPrices').length > 0)
		{
			sParams += '&view=true';
		}
		else
		{
			sParams += '&view=false';
		}

		var oCall = callAjax("bulkprices", sParams, "post");
		// process feedback
		oCall.success(function(oData)
		{
			if(oData.errorType === '')
			{
				if($('.bulkPrices').length > 0)
				{
					if(oData.data.length > 0)
					{
						var sBulkPrices = '<ul>';
						// Show prices on detail page
						for(i=0;i<oData.data.length;i++)
						{
							if(typeof oData.data[i].price_promo !== 0)
							{
								sBulkPrices += '<li class="bulkprice">' + oData.data[i].quantity + ' ' + sItemPlural + ': <span class="strike-through">' + parseFloat(oData.data[i].price).toFixed(2) + sCurrencySign + '</span>';
								sBulkPrices += '<span>' + parseFloat(oData.data[i].price_promo).toFixed(2) + sCurrencySign + '</span>';
							}
							else
							{
								sBulkPrices += '<li class="bulkprice">' + oData.data[i].quantity + ' ' + sItemPlural + ': <span>' + parseFloat(oData.data[i].price).toFixed(2) + sCurrencySign + '</span>';
							}
							sBulkPrices += '</li>';
						}
						sBulkPrices += '</ul>';

						$('.bulkPrices').html(sBulkPrices);
						$('.bulk').removeClass('hide');
					}
					else
					{
						$('.bulk').addClass('hide');
					}
				}
				else
				{
					$('.bulkUnitPrices').html(oData.html);
					var oBulkUnitPricesHeading = $('.bulkUnitPrices thead th:last-child');
					oBulkUnitPricesHeading.append(' ' + sItemSingle);
					if(typeof sFreeText2 !== 'undefined' && sFreeText2 !== '')
					{
						oBulkUnitPricesHeading.append(' (' + sFreeText2 + ')');
					}

					// Set bulk discount percentage
					if($('.bulkDiscountPercentage').length > 0)
					{
						$('.bulkDiscountPercentage').each(function()
						{
							var productPrice = (productPricePromo !== 0)?productPricePromo:productPriceStandard;
							var discount = productPrice - parseFloat($(this).data('price'));

							if(productPrice !== 0 && (parseInt((discount/productPrice)*100) !== 0))
							{
								var percentage = parseInt((discount/productPrice)*100);
								$(this).html('(-'+ percentage +'%)');
								$(this).parent('.itemprice').find('.strike-through').html(sCurrencySign + ' ' + productPriceStandard.toFixed(2).replace('.',','));
							}
						});
					}
					if($('.orderUnitPlural').length > 0)
					{
						$('.orderUnitPlural').each(function()
						{
							$(this).html(sItemPlural);
						});
					}
					if(typeof oData.maxQuantityPrice !== "undefined" && $(".maxQuantityPrice").length > 0)
					{
						$('.maxQuantityPrice .price').html(oData.maxQuantityPrice);
					}
				}
			}
			else
			{
				$('.bulk').removeClass('hide');
				// show error message
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
			}
		});
	}
}

function switchDescriptionSize(){
	var button  = $("#showMoreOrLess");
	var textBox = $('#descriptionBox');
	var divHeight = $('#descriptionBox').prop("scrollHeight");
	if(button.html() === sShowMoreText + ' <i class="fas fa-angle-down"></i>'){
		button.html(sShowLessText + ' <i class="fas fa-angle-up"></i>');
		textBox.css('height', divHeight);
	}
	else {
		button.html(sShowMoreText + ' <i class="fas fa-angle-down"></i>');
		textBox.css('height', "80px");
	}
}

function setVisibilityOfShowMore() {
	var el = $('#descriptionBox');
	var divHeight = $('#descriptionBox').outerHeight();
	var button  = $("#showMoreOrLess");
	if (divHeight > 84) {
		el.css('height', '80px');
	} else {
		el.css('height', 'auto');
		button.css('display', 'none');
	}
	el.css('visibility', 'visible');
	button.css('visibility', 'visible');
}

function getSkuQty()
{
	var iQty = $('#edtQty').val();
	if(iQty > 9999)
	{
		iQty = 9999;
	}

	if(typeof oSelectedSizeData.stock !== "undefined")
	{
		var iStock = parseInt(oSelectedSizeData.stock);
		if(iStock !== 0 && sShopOnline !== 'always_order_always')
		{
			if(iQty > iStock)
			{
				iQty = iStock;
				$('#edtQty').val(iStock);
			}
		}
	}

	return iQty;
}

function getSelectedSku()
{
	// Clear previous errors
	clearErrors();

	var selectedColour = oSelectedSizeData.idColour;
	var selectedSku    = oSelectedSizeData.value;
	if(selectedSku == '-1' || selectedColour == '-1')
	{
		showAlert('error', tSelectColourSize, false);
		return '';
	}
	else
	{
		return selectedSku;
	}
}

// Handler for changing colours, this gets the data specific to the type of colour switcher. It triggers the next set of functions based on that value
function handleColourChange(element,type){

	// Switch colour reference
	var supplierRef = element.data('supplierRef');
	if(supplierRef !== '')
	{
		$('.selectedColour').show().find('.reference').text(supplierRef);
	}
	else
	{
		$('.selectedColour').hide();
	}

	var sOverlayDateTo = element.data('overlayDateTo');
	if(typeof sOverlayDateTo !== "undefined" && sOverlayDateTo !== "")
	{
		$(".endDatePromo").text(sPromoEndDateFormattedLabel + ' ' + sOverlayDateTo);
	}
	else
	{
		$(".endDatePromo").hide();
	}

	switch(type){
		case 'dropdown':
			if($(el('size' + element.val())).is(':hidden')){
				$('.selectSizes').hide();
				$(el('size' + element.val())).show();
			}
			if (element.find("option:selected").attr('disabled') == "disabled") {
				$('#btnAddProduct, #btnAddProductBottomTrigger, #edtQty, .collect, .btnIsHomeDelivery').prop('disabled', true);
			} else {
				$('#btnAddProduct, #btnAddProductBottomTrigger, #edtQty, .collect, .btnIsHomeDelivery').prop('disabled', false);
				disableQtyEdit();
			}
			changeColour(element.val());
			checkOneSize();
			break;
		case 'swatch':
			$('.swatch-item').removeClass('selected');
			element.addClass('selected');

			var bShowSelectedColour = (typeof element.data('useInProductDescription') !== "undefined") ? element.data('useInProductDescription') : true;
			if(element.children('img').length > 0){
				if(bShowSelectedColour)
				{
					$('.selected-swatch-descr').html(element.children('img').attr('title'));
				}
				//Show supplier reference
				$('.selected-swatch-supplier').html(element.children('img').attr('data-ref'));
			}
			else{
				if(bShowSelectedColour)
				{
					$('.selected-swatch-descr').html(element.html());
				}
			}

			//Selects first size.Important to define price/promo
			if($(el('size' + element.data('value'))).is(':hidden')){
				$('.selectSizes').siblings('.hide').hide();
				$(el('size' + element.data('value'))).show();
			}

			//Defines main product image
			changeColour(element.data('value'));
			break;
		}
}
// Handler for changing sizes, this triggers the size specific switcher logic and triggers the next set of functions
function handleSizeChange(element,type){
	switch(type){
		case 'dropdown':
			$('.hdDeliveryPromise').html(element.data('hdpromise'));
			$('.ccDeliveryPromise').html(element.data('ccpromise'));
			if(element.hasClass('disabled')){
				$('#btnAddProduct, #btnAddProductBottomTrigger, .collect, .btnIsHomeDelivery').prop('disabled',true);
			}
			else{
				$('#btnAddProduct, #btnAddProductBottomTrigger, .collect, .btnIsHomeDelivery').prop('disabled',false);
				disableQtyEdit();
			}
		break;
		case 'swatch':
			$('.size-item').removeClass('selected');
			element.addClass('selected');
			$('.selected-size-descr').html(element.html());
			if (element.html().toLowerCase().trim() === 'overige' || element.html().toLowerCase().trim() === 'nocolour' || element.html().toLowerCase().trim() === 'n/a') {
				$('.selected-size-wrapper').hide();
			} else {
				$('.selected-size-descr').html(element.html());
			}

			$('.hdDeliveryPromise').html(element.data('hdpromise'));
			$('.ccDeliveryPromise').html(element.data('ccpromise'));
			if(element.hasClass('disabled')){
				// If A2B setting is on when Click collect stores has the product, do NOT disable the button
				if (bDoNotDisplayHDBlockedOnPDP) {
					$('#btnAddProduct, #btnAddProductBottomTrigger, .collect, .btnIsHomeDelivery').prop('disabled',false);
				} else {
					$('#btnAddProduct, #btnAddProductBottomTrigger, .collect, .btnIsHomeDelivery').prop('disabled',true);
				}
			}
			else{
				$('#btnAddProduct, #btnAddProductBottomTrigger, .collect, .btnIsHomeDelivery').prop('disabled',false);
				disableQtyEdit();
			}
		break;
	}

	var sPostalCode = $(el('edtPostalcode')).val();

	if(bLoadCollectInAdvance == 1)
	{
		findShops(sPostalCode);
	}

	if(oSelectedSizeData.value != '-1')
	{
		updatePrice(oSelectedSizeData);
	}

	if(bEnableNewWishlist) {
		if (sWishlistProducts.indexOf(oSelectedSizeData.value.toString()) >= 0) {
			$(el("addToWishlist")).replaceWith('<i class="fa fa-heart icon-heart" id="removeFromWishlist"></i>');
		} else {
			$(el("removeFromWishlist")).replaceWith('<i class="fa fa-heart-o icon-heart-empty" id="addToWishlist"></i>');
		}
	}

	if(typeof aQuantities !== 'undefined' && aQuantities !== '')
	{
		getBulkPrices();
	}

	updateOverlay();
	updateDiscountLabel(oSelectedSizeData.isPromo);

	/*LOGIC FOR ALMOST SOLD OUT/SOLD OUT PRODUCTS */

	$('.stockAmount').html(  oSelectedSizeData.stock );
	if (oSelectedSizeData.stock > 0) {
		$('.stockAvailable').css('display', 'block');
		$('.stockUnavailable').css('display', 'none');
	} else {
		$('.stockAvailable').css('display', 'none');
		$('.stockUnavailable').css('display', 'block');
	}
	//If pdp_sold exists
	if( typeof sCheckSoldOut !== 'undefined' && sCheckSoldOut && typeof sCheckSoldOutText !== 'undefined' && sCheckSoldOutText ){
		if (oSelectedSizeData.stock <= sCheckSoldOut){
			//Sold out, pdp_sold defined
			$('#stockEnded').css('display', 'block');
			$('#stockEnded').html(  sCheckSoldOutText );
		}
		else if( oSelectedSizeData.stock <= sCheckStockAlmostSoldOut){
			if( typeof sCheckStockAlmostSoldOut !== 'undefined' && sCheckStockAlmostSoldOut && typeof sCheckStockAlmostSoldOutText !== 'undefined' && sCheckStockAlmostSoldOutText ){
				//Almost sold out, pdp_sold defined (but not sold out yet)
				$('#stockEnding').css('display', 'block');
				$('#stockEnding').html( sCheckStockAlmostSoldOutText);
			}
		}
	}
	//pdp_sold not defined
	else if ( typeof sCheckStockAlmostSoldOut !== 'undefined' && sCheckStockAlmostSoldOut && typeof sCheckStockAlmostSoldOutText !== 'undefined' && sCheckStockAlmostSoldOutText ){
		if( oSelectedSizeData.stock <= sCheckStockAlmostSoldOut){
			//Almost sold out, pdp_sold not defined
			$('#stockEnding').css('display', 'block');
			$('#stockEnding').html( sCheckStockAlmostSoldOutText );
		}
	}

	var sProductSku = element.data('value');

	if(typeof sProductSku !== "undefined" && sProductSku !== '') {
		$('.skuId').text( sProductSku );
	}
	if(typeof oSelectedSizeData.uomCode !== "undefined" && typeof oSelectedSizeData.uomQty !== "undefined")
	{
		var sUomDescription = "<p><strong>" + oSelectedSizeData.uomCode + ":</strong>" + " " +  oSelectedSizeData.uomQty + "</p>";

		$(".uomDescription").html(sUomDescription);
	}
	if(typeof oSelectedSizeData.content !== "undefined" && typeof oSelectedSizeData.unit !== "undefined")
	{
		var sContentPerUnit = "<p><strong>" + oSelectedSizeData.unit + ":</strong>" + " " + oSelectedSizeData.content + "</p>";

		$(".contentPerUnit").html(sContentPerUnit);
	}
}

function initVersionEditionVariants()
{
	uAjax = "/index.cfm/product/ajax/setversioneditionvariants";

	var sParams = '&productId=' + sProductId;
	var oCall   = callAjax("setversioneditionvariants", sParams, "post");

	// process feedback
	oCall.success(function(oData)
	{
		if(oData.errorType === "" && oData.html !== "")
		{
			$('.initVersionEditionVariants').html(oData.html);
		}
		else
		{
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function checkNotifyMe() {
	if ($("#btnNotifyMe").length > 0) {
		if (notifymeproducts !== "undefined" && !Array.isArray(notifymeproducts))
			notifymeproducts = JSON.parse(notifymeproducts);

		var bNotifyMeExists=false;
		$.each(notifymeproducts, function( index, value ) {
			if(value==oSelectedSizeData.value)
			{
				bNotifyMeExists=true;
			}
		});

		if (bNotifyMeExists) {
			// exists
			$("#btnNotifyMe .btnText").text(tNotifyMeSubscribed);
			$("#btnNotifyMe").data("remove", true);
		} else {
			$("#btnNotifyMe .btnText").text(tNotifyMeBtn);
			$("#btnNotifyMe").data("remove", false);
		}
	}
}

function triggerBasketAction(oData)
{
	if(typeof oData.addskupopup !== "undefined")
	{
		// trigger modal with upsell products
		$('#addSkuPopup').html(oData.addskupopup);
		$('#addSkuPopup .modal').modal('show');
		centerPopups();

		// update basketdropdown but don't show
		$('#basketDropdown').html(oData.html);
	}
	else
	{
		$('#basketDropdown').html(oData.html).delay(300).queue(function (next)
		{
			if(!bScanMode)
			{
				$(this).addClass("open");

				setTimeout(function () {
					if ($('#basketDropdown').is(':visible')) {
						$('#basketDropdown').removeClass('open');
					}
				}, 3000);
			}
			else
			{
				$('.siteSearch.scanmode').find('input').focus();
			}

			next();
		});

		$('html, body').animate({scrollTop: '0px'}, 300);
	}
}
function updateDiscountLabel(bPromo)
{
	var numericPriceRecommended= (typeof oSelectedSizeData.priceRecommended !== 'undefined') ? Number(oSelectedSizeData.priceRecommended.replace('.','').replace(',-','').replace(/[^0-9.,]*/g,'').replace(',','.')) : 0;
	var numericPriceStandard = Number(oSelectedSizeData.price.replace(/[^0-9.,]*/g,'').replace(',','.'));
	var numericPricePromo    = Number(oSelectedSizeData.pricePromo.replace(/[^0-9.,]*/g,'').replace(',','.'));

	if(bPromo)
	{

		if(numericPriceStandard > 0 && numericPriceStandard > numericPricePromo)
		{
			var percentage = ((numericPriceStandard - numericPricePromo)/numericPriceStandard) * 100;
			if(bRoundDisountLabel)
			{
				percentage = (Math.round(percentage / 5)) * 5;
			}
			else
			{
				percentage = Math.round(percentage);
			}
			if (percentage >= 1) {
				$('.discountLabel').html('-'+percentage+'%').show();
			} else {
				$('.discountLabel').hide();
			}
		}
	}
	else
	{
		$('.discountLabel').hide();
	}
}

function updateOverlay() {
	if (typeof oSelectedSizeData.overlay !== "undefined" && oSelectedSizeData.overlay !== "") {
		$(".deliveryOverlay").prop("src", oSelectedSizeData.overlay).removeClass("hidden");
	} else {
		$(".deliveryOverlay").addClass("hidden");
	}
}

function init()
{
	// show correct sizes
	var bZoom = (typeof bEnableZoomPdt !== 'undefined') ? bEnableZoomPdt : 0;
	var sSwatchIdentifier = '.selected';

	// Check if colour is supplied as param
	if(bColourId !== -1)
	{
		$('.selectColour').val(bColourId);

		// Check if colour is available
		if($('.swatch-item[data-value="' + bColourId + '"]').length === 0)
		{
			// Set to first available colour
			bColourId = $('.swatch-item:first').data('value');
		}

		sSwatchIdentifier = '[data-value="'+bColourId+'"]';
	}

	if($('.selectColour > option').length > 0){
		$('.selectColour').trigger('change');
	}
	else
	{
		$('.swatch-item' + sSwatchIdentifier).trigger('click');
	}

	if($('.size-item.selected').length > 0)
	{
		populateSizeData($('.size-item.selected'),'swatch');
		updatePrice();
	}

	if(typeof bDontTriggerFirstClick !== 'undefined' && bDontTriggerFirstClick)
	{
		// Add click event listeners to .swatch-item and .size-item
		$('.swatch-item, .size-item').on('click', function()
		{
			if ($('.swatch-item.selected').length > 0 )
			{
				$('#selection-title').removeClass('redWarningText');
				$('.product-a2b .input-prepend.input-append').removeClass('redWarningText');
				$('#selection-title').find("> span").hide();
				$('#selection-title').find(".selected-swatch-descrWrapper").show();
			}
			if($('.size-item.selected').length > 0)
			{
				$('#selectSizeText').removeClass('redWarningText');
				$('.product-a2b .input-prepend.input-append').removeClass('redWarningText');
				$('#selectSizeText').find("> span").hide();
				$('#selectSizeText').find(".selected-size-descrWrapper").show();
			}
		});
	}

	initSliders();

	if(bZoom && screenWidth > 768)
	{
		initZoom();
	}

	if(typeof sChannel !== 'undefined' && sChannel === 'B2B' && typeof bUserIsAgent !== 'undefined' && bUserIsAgent === true && typeof oSelectedSizeData.stock !== 'undefined')
	{
		$('.selectedSizeStock').html('(' + oSelectedSizeData.stock + ')');
	}

	disableQtyEdit();

	if($('.modelsFiltersContainer').length > 0)
	{
		$('.modelsFiltersContainer').find('.filter').each(function()
		{
			if($(this).find('.filter-item.selected').length == 0)
			{
				// select first filter option
				$(this).find('.filter-item:first').addClass('selected');
			}
		});
	}

	if(bCustomerHash && $('.toggleCreateReviewModal').length > 0)
	{
		$('.toggleCreateReviewModal').trigger('click');
	}
}

function initProductPictureSlider(sColour)
{
	// product pictures thumbs
	var oThumbs = $(el('productImagesThumbs' + sColour ));

	// prefer responsive thumbslider
	var oThumbSlider = $('#productImagesThumbs' + sColour)
	if(oThumbSlider.hasClass('responsive'))
	{
		var iInnerWidth = oThumbSlider.parents('.product-img').innerWidth();
		setSlider(oThumbSlider, iInnerWidth, undefined,'#productImages' + sColour);
	}
	else
	{
		var sDirection = (typeof $('#productImagesThumbs' + sColour).data("direction") !== "undefined")? $('#productImagesThumbs' + sColour).data("direction") : "horizontal";
		var itemWidth = (typeof $('#productImagesThumbs' + sColour).data("direction") !== "undefined")? $('#productImagesThumbs' + sColour).data("itemWidth") : fsItemWidth;
		var itemCount = (typeof $('#productImagesThumbs' + sColour).data("itemCount") !== "undefined")? $('#productImagesThumbs' + sColour).data("itemCount") : undefined;

		// bw compatible
		$('#productImagesThumbs' + sColour).flexslider({
			animation    : "slide",
			animationLoop: false,
			asNavFor     : '#productImages' + sColour,
			direction    : sDirection,
			controlNav   : false,
			itemMargin   : flexsliderMargin,
			itemWidth    : itemWidth ,
			minItems     : itemCount,
			maxItems     : itemCount,
			slideshow    : false,
			touch        : true,
			useCSS       : true
		});
	}

	// large product pictures
	$(el('productImages' + sColour)).flexslider({
		animation: "fade",
		animationLoop: false,
		controlNav: fsControlNav,
		slideshow: false,
		sync: "#productImagesThumbs" + sColour,
		touch: true,
		useCSS: true
	});

	// hide thumbs if only 1
	if(oThumbs.find('img, .iconWrapper').length === 1)
	{
		oThumbs.hide();
	}

	$('.productImagesContainer.colour' + sColour).show();
}

function initSliders()
{
	var oSlider = $('.detailRelated .flexslider');

	if(oSlider.length > 0)
	{
		if(oSlider.hasClass('responsive'))
		{
			var iInnerWidth = $('.detailRelated').innerWidth();

			setSlider(oSlider, iInnerWidth);
		}
		else
		{
			// backwards compatible
			if($(window).width() < 768)
			{
				oSlider.flexslider({
					animation: "slide",
					animationLoop: false,
					controlNav: false,
					itemMargin: 0,
					slideshow: false,
					touch: true
				});
			}
			else
			{
				oSlider.flexslider({
					animation: "slide",
					animationLoop: false,
					controlNav: false,
					directionNav: true,
					itemMargin: 30,
					itemWidth: 270
				});
			}
		}
	}

	var oRecentlyViewedSlider = $('.recentlyViewedProducts .flexslider');
	if(oRecentlyViewedSlider.length > 0)
	{
		if(oRecentlyViewedSlider.hasClass('responsive'))
		{
			var iInnerWidth = $('.recentlyViewedProducts').innerWidth();
			setSlider(oRecentlyViewedSlider, iInnerWidth);
		}
		else
		{
			// backwards compatible
			if($(window).width() < 768)
			{
				oRecentlyViewedSlider.flexslider({
					animation: "slide",
					animationLoop: false,
					controlNav: false,
					itemMargin: 0,
					slideshow: false,
					touch: true
				});
			}
		}
	}

	var oCustomProductImageSlider = $('.customProductImageSlider .flexslider');
	if(oCustomProductImageSlider.length > 0)
	{
		if(oCustomProductImageSlider.hasClass('responsive'))
		{
			var iInnerWidth = $('.customProductImageSlider').innerWidth();
			setSlider(oCustomProductImageSlider, iInnerWidth);
		}
	}
}

function initZoom()
{
	$('a.fancybox').swinxyzoom({
		mode: 'dock'
		, damping: false
		, controls: false
	});

	$('.product-img').delegate('.sxy-zoom-viewfinder', 'click', function()
	{
		$(this).parents('.sxy-zoom-container').find('.fancybox').trigger('click');
	});
}

function deleteLine(oBtn)
{
	oBtn.prop("disabled", true);

	var sSkuId = oSelectedSizeData.value;

	var sParams = '&skuId=' + sSkuId + '&fromlisterorpdp=true';;
	var oCall   = callAjax("deleteLine", sParams, "post", "/index.cfm/wishlist/ajax/deleteLine");
	oCall.success(function(oData)
	{
		if(oData.errorMessage === '')
		{
			$("#mainContainer header .wishlistWrapper").replaceWith(oData.headerLinksHtml);
			$(el("removeFromWishlist")).replaceWith('<i class="fa fa-heart-o icon-heart-empty" id="addToWishlist"></i>');
			ciResponsive.process();
		}
		else
		{
			showAlert('error', oData.errorMessage, false, 3000);
		}

		oBtn.prop("disabled", false	);
	});
}

function loadFinanceOptions(iAmount)
{
	uAjax = "/index.cfm/product/ajax/getpaymentoptions";

	var sParams = "&amount=" + iAmount;
	var oCall   = callAjax("getpaymentoptions", sParams, "post");
	oCall.success(function (oData)
	{
		if (oData.errorType == '')
		{
			$(".productFinanceOptions").html(oData.html);
		}
		else {
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function makePositiveValue()
{
	var quantityField = $(".input-quantity");
	var quantityFieldValue = quantityField.val();
	var positiveValue = Math.abs(quantityFieldValue);
	quantityField.val(positiveValue);
}

// Handler for changing sizes, this gets the data specific to the type of size switcher and stores it in a generic way for further processing
function populateSizeData(element,type){
	switch(type){
		case 'dropdown':
			oSelectedSizeData = element.find(":selected").data();
			oSelectedSizeData.value = element.val();
			oSelectedSizeData.idColour = element.attr('id').replace('size','');
			break;
		case 'swatch':

			if(typeof element.data('empty-price') !== 'undefined')
			{
				var emptyPrice = element.data('empty-price');
			}
			else
			{
				var emptyPrice = false;
			}

			$('.selectSizes').val(element.data('value'))
				.data('price',element.data('price'))
				.data('price-promo',element.data('price-promo'))
				.data('is-promo',element.data('is-promo'))
				.data('stock',element.data('stock'))
				.data('has-stock',element.data('has-stock'))
				.data('idColour',element.parent().attr('id').replace('size',''))
				.data('hdpromise',element.data('hdpromise'))
				.data('price-recommended',element.data('price-recommended'))
				.data('empty-price',emptyPrice)
				.data('disabled', element.hasClass('disabled'))
				.data('overlay', element.data('overlay'))
				.data('endoflife', element.data('endoflife'))
				.data('end-date-promo', element.data('end-date-promo'))
				.data('lendout-monthlyprice', element.data('lendout-monthlyprice'))
				.data('uomCode', element.data('uomCode'))
				.data('uomQty', element.data('uomQty'))
				.data('content', element.data('content'))
				.data('unit', element.data('unit'));

			oSelectedSizeData = $('.selectSizes').data();
			if (typeof oSelectedSizeData.endoflife === "undefined") oSelectedSizeData.endoflife = false;
			oSelectedSizeData.value  =  $('.selectSizes').val();
			break;
	}
}

function preventNegativeValue()
{
	var quantityField = $(".input-quantity");

	quantityField.keypress(function(event)
	{
		if ( event.which == 45 ) {
			event.preventDefault();
		}
	});

}

function setButtonStates(collectMethodsUsed)
{
	// if pickupoint is selected, disable hd & cc
	if(collectMethodsUsed.indexOf('pickup_point') > -1)
	{
		$('#ccShops button').prop('disabled', true);
		$('#btnAddProduct').attr('id', 'btnAddProductDisabled').prop('disabled', true);
		$('.btnIsHomeDelivery').prop('disabled', true);
	}
	else
	{
		$('#pickuppoints button').prop('disabled', true);
	}
};

function showProductImages(sColour)
{
	$('.productImagesContainer').hide();
	initProductPictureSlider(sColour);
}

// Floor rounding function with fixed zero digits to avoid unstable results (wrong rounding) in some older/outdated browsers.
function roundedToFixed(input, digits, zeroAmount){
	var zeroString = '';
	while (zeroAmount !== 0) {
		zeroString = zeroString + '0';
		zeroAmount--;
	}
	var rounder = Math.pow(10, digits);
	return (Math.floor(input * rounder) / rounder).toFixed(digits) + zeroString;
}

function updatePrice()
{
	var standardPrice = oSelectedSizeData.price;
	var promoPrice = oSelectedSizeData.pricePromo;
	var recommendedPrice = (typeof oSelectedSizeData.priceRecommended !== 'undefined') ? oSelectedSizeData.priceRecommended : "";
	var isPromo = oSelectedSizeData.isPromo;
	var endDataPromo = (typeof oSelectedSizeData.endDatePromo !== 'undefined') ? oSelectedSizeData.endDatePromo : "";
	// set numeric pricestandard & promo - used for bulkprices calc
	var numericPriceStandard = Number(standardPrice.replace('.','').replace(',-','').replace(/[^0-9.,]*/g,'').replace(',','.'));
	var numericPricePromo    = Number(promoPrice.replace('.','').replace(',-','').replace(/[^0-9.,]*/g,'').replace(',','.'));
	var numericPriceRecommended    = Number(recommendedPrice.replace('.','').replace(',-','').replace(/[^0-9.,]*/g,'').replace(',','.'));

	// Check loyalty section existance
	var hasLoyaltySection = false;
	var loyaltySection        = $(".loyaltyWrapper");
	if (nProductMaxDiscount > 0 && loyaltySection.length > 0 && nLoyaltyPointsTranche !== 0 && nLoyaltyPointsPercentage !== 0 && nLoyaltyPointsFactor !== 0) {
		hasLoyaltySection = true;
	} else {
		$(".loyaltyWrapper").hide();
	}
	if(!isNaN(productPriceStandard) && !isNaN(productPricePromo))
	{
		productPriceStandard = numericPriceStandard;
		productPricePromo = numericPricePromo;
		productPriceRecommended = numericPriceRecommended;
	}
	if(typeof oSelectedSizeData.emptyPrice !== 'undefined')
	{
		var isZero = oSelectedSizeData.emptyPrice;
	}
	else
	{
		var isZero = false;
	}

	var oPriceEl                       = $('.product-price .price');
	var bHasBulkPricesAndMaxQuantityEl = false;

	if(typeof aQuantities !== "undefined" && aQuantities !== "" && oPriceEl.parents(".product-price").hasClass("maxQuantityPrice"))
	{
		bHasBulkPricesAndMaxQuantityEl=true;
	}
	if(isZero)
	{
		oPriceEl.html(tNoPrice).addClass('noPrice');
		$('#btnAddProduct, #btnPreOrderAddProductBottomTrigger, #btnAddProductBottomTrigger, .btnIsHomeDelivery').prop('disabled',true);
	}
	else
	{
		oPriceEl.removeClass('noPrice');

		if(!bHasBulkPricesAndMaxQuantityEl)
		{
			if(isPromo !== 1)
			{
				oPriceEl.removeClass('hasPromo');
				oPriceEl.html(standardPrice);
				// Update loyalty points value based on price
				if (hasLoyaltySection) {
					if (numericPriceStandard >= nLoyaltyPointsTranche) {
						$('.loyaltyWrapper').show();
						$('.loyaltyPointAmount').html(Math.trunc(((((numericPriceStandard / nLoyaltyPointsTranche) * nLoyaltyPointsTranche) * nLoyaltyPointsPercentage)) / nLoyaltyPointsFactor));
						$('.loyaltyPointAmountBase').html(sCurrencySign + roundedToFixed(((Math.trunc(numericPriceStandard / nLoyaltyPointsTranche) * nLoyaltyPointsTranche) * nLoyaltyPointsPercentage),1,1));
					} else {
						$('.loyaltyWrapper').hide();
					}
				}
			}
			else
			{
				oPriceEl.addClass('hasPromo');
				oPriceEl.html('<span class="strike-through">' + standardPrice + '</span>' + promoPrice);

				if(endDataPromo !== "")
				{
					$(".endDatePromo").html(sPromoEndDateFormattedLabel + ' ' + endDataPromo).show();
				}
				// Update loyalty points value based on promo price
				if (hasLoyaltySection) {
					if (numericPricePromo >= nLoyaltyPointsTranche) {
						$('.loyaltyWrapper').show();
						$('.loyaltyPointAmount').html(Math.trunc(((((numericPricePromo / nLoyaltyPointsTranche) * nLoyaltyPointsTranche) * nLoyaltyPointsPercentage)) / nLoyaltyPointsFactor));
						$('.loyaltyPointAmountBase').html(sCurrencySign + roundedToFixed(((Math.trunc(numericPricePromo / nLoyaltyPointsTranche) * nLoyaltyPointsTranche) * nLoyaltyPointsPercentage),1,1));
					} else {
						$('.loyaltyWrapper').hide();
					}
				}
			}
		}
		var totalRecommendedPrice = numericPriceRecommended;
		var totalPromoPrice = (isPromo ? numericPricePromo : 0);
		var totalStandardPrice = numericPriceStandard;
		if ($("input[type=radio].addonRadio:checked").length > 0) {
			$("input[type=radio].addonRadio:checked").each(function() {
				var oSelectedOption = $(this);
				var numericAddonPrice = Number(oSelectedOption.data("price").replace('.','').replace(',-','').replace(/[^0-9.,]*/g,'').replace(',','.'));
				totalPromoPrice = (isPromo && totalPromoPrice + numericAddonPrice);
				totalStandardPrice = numericAddonPrice + totalStandardPrice;
				totalRecommendedPrice = numericAddonPrice + totalRecommendedPrice;
			});
			if (isPromo !== 1) {
				oPriceEl.html(sCurrencySign + ' ' + totalStandardPrice.toFixed(2).replace('.',','));
			} else {
				oPriceEl.html('<span class="strike-through">' + sCurrencySign + ' ' + totalStandardPrice.toFixed(2).replace('.',',') + '</span>' + sCurrencySign + ' ' + totalPromoPrice.toFixed(2).replace('.',','));
			}
		}
		oPriceEl.removeClass('hasRecommendedLabel');
		if(totalRecommendedPrice > 0) {
			var sPricesHtml = ''
			if (totalPromoPrice == totalRecommendedPrice) {

				var discount = totalStandardPrice - totalPromoPrice;
				var percentage = parseInt((discount/totalStandardPrice)*100);

				oPriceEl.addClass('hasRecommendedLabel');
				oSelectedSizeData.isPromo = 0;
				sPricesHtml += '<span class="standardPrice"><span class="recommendedPriceLabel">' + sRecommendedPriceLabel + ' </span><span class="recommendedPriceValue">' + sCurrencySign + ' ' + totalStandardPrice.toFixed(2).replace('.',',') + '</span></span></span>'
				sPricesHtml += '<span class="discountRecommendedPercentage"><span class="recommendedDiscountLabel">' + sDiscountRecommendedPriceLabel + ' </span><span class="recommendedPercentageDisc">%' + percentage + '</span></span></span>'
				sPricesHtml += '<span class="promoPrice">' + sCurrencySign + ' ' + totalPromoPrice.toFixed(2).replace('.',',') + '</span>'
			} else if (totalPromoPrice != totalRecommendedPrice && isPromo) {
				sPricesHtml += '<span class="recommendedPrice strike-through">' + sCurrencySign + ' ' + totalStandardPrice.toFixed(2).replace('.',',') + '</span>'
				sPricesHtml += '<span class="promoPrice">' + sCurrencySign + ' ' + totalPromoPrice.toFixed(2).replace('.',',') + '</span>'
			} else if (totalStandardPrice < totalRecommendedPrice) {
				sPricesHtml += '<span class="standardPrice">' + sCurrencySign + ' ' + totalStandardPrice.toFixed(2).replace('.',',') + '</span>'
			} else {
				sPricesHtml += '<span class="standardPrice">' + sCurrencySign + ' ' + totalStandardPrice.toFixed(2).replace('.',',') + '</span>'
			}
			oPriceEl.html(sPricesHtml);
		}
	}
	if(bCanFinance)
	{
		loadFinanceOptions((isPromo)?numericPricePromo:numericPriceStandard);
	}

	if(typeof oSelectedSizeData.lendoutMonthlyprice !== 'undefined')
	{
		var oPriceEl = $('.lendingOrderPrice .price');
		oPriceEl.html(oSelectedSizeData.lendoutMonthlyprice);
	}
}